import { CenterReportAbstractSelect } from '@/module/Laboratory/criteria/CenterReportAbstractSelect';
import { CenterReportArticleSelect } from '@/module/Laboratory/criteria/CenterReportArticleSelect';
import { CenterReportAwardSelect } from '@/module/Laboratory/criteria/CenterReportAwardSelect';
import { CenterReportProceedingSelect } from '@/module/Laboratory/criteria/CenterReportProceedingSelect';
import { CenterReportProjectSelect } from '@/module/Laboratory/criteria/CenterReportProjectSelect';
import { ReportCriteriaSelectType } from '@/module/ResearchCenter';

import { Id } from '@feature/utils';

interface CenterReportCriteriaSelectProps {
  labId: Id;
  criteriaCode: string;
  selectType: ReportCriteriaSelectType;
}

export function CenterReportCriteriaSelect({ labId, criteriaCode, selectType }: CenterReportCriteriaSelectProps) {
  return (
    <>
      {selectType === 'PROJECT' && (
        <CenterReportProjectSelect
          labId={labId}
          criteriaCode={criteriaCode}
        />
      )}
      {selectType === 'AWARD' && (
        <CenterReportAwardSelect
          labId={labId}
          criteriaCode={criteriaCode}
        />
      )}
      {selectType === 'ARTICLE' && (
        <CenterReportArticleSelect
          labId={labId}
          criteriaCode={criteriaCode}
        />
      )}
      {selectType === 'PROCEEDING' && (
        <CenterReportProceedingSelect
          labId={labId}
          criteriaCode={criteriaCode}
        />
      )}
      {selectType === 'ABSTRACT' && (
        <CenterReportAbstractSelect
          labId={labId}
          criteriaCode={criteriaCode}
        />
      )}
    </>
  );
}
